export const EquipmentUnitList = [
  { id: "l", name: "Litre" },
  { id: "m3", name: "M³" },
];


export const EquipmentUnitListLabels: Record<string, string> = EquipmentUnitList.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);